// The const assertion preserves the literal value types for TypeScript
// consumers (navigation.ts derives the RouteName union from this table, which
// is what compile-checks every transition target and useNavigation anchor).
const names = /** @type {const} */ ({
  CODE_INPUT: 'code-input',
  CODE_QUESTION: 'code-question',
  INSURANCE_COVERED: 'insurance-covered',
  CORP_KEY: 'corp-key',
  DEEPLINK_FALLBACK: 'deeplink-fallback',
  DOWNLOAD_LINK: 'download-link',
  CONTEXTUAL_DOWNLOAD_LINK: 'contextual-download-link',
  INSURANCE_DETAILS: 'insurance-details',
  INSURANCE_OVERVIEW: 'insurance-overview',
  INSURANCE_SELECTION: 'insurance-selection',
  INSURANCE_PRESCRIPTION_PRIVATE: 'insurance-prescription-private',
  INSURANCE_SEARCH_PRIMER: 'insurance-search-primer',
  INSURANCE_VERIFICATION_HUK: 'insurance-verification-huk',
  INSURANCE_VERIFICATION_PRIVATE: 'insurance-verification-private',
  PASSWORD_RESET: 'password-reset',
  PRESCRIBER_INFORMATION: 'prescriber-information',
  PRESCRIPTION_ACTIVATION: 'prescription-activation',
  PRESCRIPTION_APPOINTMENT: 'prescription-appointment',
  PRESCRIPTION_CHECK: 'prescription-check',
  PRESCRIPTION_GUIDANCE: 'prescription-guidance',
  PRESCRIPTION_INSURANCE: 'prescription-insurance',
  PHONE_INPUT: 'phone-input',
  PHONE_INPUT_INSURANCE: 'phone-input-insurance',
  PHONE_INPUT_PRESCRIBER: 'phone-input-prescriber',
  PHONE_INPUT_OUTREACH: 'phone-input-outreach',
  PHONE_INPUT_OUTREACH_CONFIRMATION: 'phone-input-outreach-confirmation',
  PHONE_INPUT_OUTREACH_MANUAL: 'phone-input-outreach-manual',
  PRESCRIPTION_QUESTION: 'prescription-question',
  PRESCRIPTION_SUPPORT: 'prescription-support',
  DOCTOR_OUTREACH_PRIMER: 'doctor-outreach-primer',
  DOCTOR_OUTREACH_PRACTICE_CONFIRMATION:
    'doctor-outreach-practice-confirmation',
  DOCTOR_OUTREACH_ADD_PRESCRIBER: 'doctor-outreach-add-prescriber',
  DOCTOR_OUTREACH_PRESCRIBER_SEARCH: 'doctor-outreach-prescriber-search',
  DOCTOR_OUTREACH_CONSENT: 'doctor-outreach-consent',
  DOCTOR_OUTREACH_CONSENT_CONFIRMATION: 'doctor-outreach-consent-confirmation',
  DOCTOR_OUTREACH_CONSENT_MANUAL: 'doctor-outreach-consent-manual',
  PRESCRIPTION_UPLOAD: 'prescription-upload',
  SESSION_EXPIRED: 'session-expired',
  SIGN_UP: 'sign-up',
  NAME_INPUT: 'name-input',
})

export default names
